export default "__VITE_ASSET__CiBdaSJz__"